export const ADMIN_EMAILS = ['admin@yalango.com'];

export function checkIsAdmin(user, idTokenResult) {
  if (!user) return false;
  const emailIsAdmin = ADMIN_EMAILS.includes(user.email);
  const claimIsAdmin = idTokenResult?.claims?.admin === true;
  return emailIsAdmin || claimIsAdmin;
}
